import { MenuToNative, MenuToNativeId } from "@/services/bridge/bridge.service";

export interface NavCurrent {
  navItemId: MenuToNativeId;
  uid?: string;
}

export const NavEnv: MenuToNative[] = [
  {
    id: MenuToNativeId.HOME_PROPERTY,
    title: "Mes propriétés",
    icon: "maps_home_work",
    link: "/home",
    show: true,
    collapse: true,
    showIconCollapse: true,
    childs: [
      {
        id: MenuToNativeId.PROP_MAIN,
        title: "Principal",
        icon: "infos",
        link: "main",
        show: false,
        collapse: true,
        showIconCollapse: true,
      },
      {
        id: MenuToNativeId.PROP_INFO,
        title: "Infos",
        icon: "info_outline",
        link: "infos",
        show: false,
        collapse: true,
        showIconCollapse: true,
        childs: [
          // rescue mode disabled
          /*{
            id: MenuToNativeId.FICHE_SECOURS,
            title: 'Fiche secours',
            icon: 'fire_truck',
            link: 'rescue',
            show: true,
            collapse: true,
            showIconCollapse: true
          },*/
          {
            id: MenuToNativeId.LOCATION,
            title: "Localisation",
            icon: "place",
            link: "location",
            show: true,
            collapse: true,
            showIconCollapse: true,
          },
          {
            id: MenuToNativeId.BUILDING,
            title: "Construction",
            icon: "foundation",
            link: "building",
            show: true,
            collapse: true,
            showIconCollapse: true,
          },
          {
            id: MenuToNativeId.ENERGY,
            title: "Energie",
            icon: "bolt",
            link: "energy",
            show: true,
            collapse: true,
            showIconCollapse: true,
          },
          {
            id: MenuToNativeId.EQUIPMENT,
            title: "Équipements",
            icon: "heat_pump",
            link: "equipments",
            show: true,
            collapse: true,
            showIconCollapse: true,
          },
          {
            id: MenuToNativeId.FINANCIAL,
            title: "Finance",
            icon: "euro",
            link: "financial",
            show: true,
            collapse: true,
            showIconCollapse: true,
          },
          {
            id: MenuToNativeId.PEOPLE,
            title: "Confidentiel",
            icon: "lock_outline",
            link: "people",
            show: true,
            collapse: true,
            showIconCollapse: true,
          },
          {
            id: MenuToNativeId.CONDOMINIUM,
            title: "Copropriété",
            icon: "holiday_village",
            link: "condo",
            show: true,
            collapse: true,
            showIconCollapse: true,
          },
        ],
      },
      {
        id: MenuToNativeId.PHOTO,
        title: "Photos",
        icon: "image",
        link: "photos",
        show: false,
        collapse: true,
        showIconCollapse: true,
      },
      {
        id: MenuToNativeId.TRACKING,
        title: "Suivis",
        icon: "update",
        link: "tracking",
        show: false,
        collapse: true,
        showIconCollapse: true,
        childs: [
          {
            id: MenuToNativeId.CONSUMPTION,
            title: "Consommations",
            icon: "leaderboard",
            link: "consumption",
            show: true,
            collapse: true,
            showIconCollapse: true,
          },
          {
            id: MenuToNativeId.MAINTENANCE,
            title: "Entretiens",
            icon: "engineering",
            link: "maintenance",
            show: true,
            collapse: true,
            showIconCollapse: true,
          },
          {
            id: MenuToNativeId.WORK,
            title: "Travaux",
            icon: "construction",
            link: "work",
            show: true,
            collapse: true,
            showIconCollapse: true,
          },
          {
            id: MenuToNativeId.TRACKING_FINANCIAL,
            title: "Finance",
            icon: "euro",
            link: "tracking-financial",
            show: true,
            collapse: true,
            showIconCollapse: true,
          } /*,
          {
            id: MenuToNativeId.TIMELINE,
            title: 'Évènements',
            icon: 'timeline',
            link: 'timeline',
            show: true,
            collapse: true,
            showIconCollapse: true
          }*/,
        ],
      },
      {
        id: MenuToNativeId.VAULT,
        title: "Documents",
        //icon: 'lock',
        icon: "folder",
        link: "vault",
        show: false,
        collapse: true,
        showIconCollapse: true,
      },
      {
        id: MenuToNativeId.PROP_SHARES,
        title: "Accès",
        icon: "share",
        link: "shares",
        show: false,
        collapse: true,
        showIconCollapse: true,
      },
      {
        id: MenuToNativeId.PROP_SERVICES,
        title: "Services",
        icon: "add_home_work",
        link: "services",
        show: false,
        collapse: true,
        showIconCollapse: true,
      },
      {
        id: MenuToNativeId.PROP_SALE,
        title: "Vente",
        icon: "real_estate_agent",
        link: "sale",
        show: false,
        collapse: true,
        showIconCollapse: true,
      },
      {
        id: MenuToNativeId.BOOKLET,
        title: "CIL",
        icon: "menu_book",
        link: "booklet",
        show: false,
        collapse: true,
        showIconCollapse: true,
      },
    ],
  },
  {
    id: MenuToNativeId.DROPBOX,
    title: "Boîte de dépôt",
    icon: "cloud_download",
    link: "/dropbox",
    chip: "",
    chipText: "De nouveaux documents sont disponibles",
    show: true,
    collapse: true,
    showIconCollapse: true,
  },
  {
    id: MenuToNativeId.SHARES,
    title: "Mes partages",
    icon: "share",
    link: "/shares",
    show: true,
    collapse: true,
    showIconCollapse: true,
  },
  {
    id: MenuToNativeId.CONNECTORS,
    title: "Mes connecteurs",
    icon: "hub",
    link: "/connectors",
    show: true,
    collapse: true,
    showIconCollapse: true,
  },
  {
    id: MenuToNativeId.CONTACTS,
    title: "Mes contacts",
    icon: "switch_account",
    link: "/contacts",
    show: true,
    collapse: true,
    showIconCollapse: true,
  },
  {
    id: MenuToNativeId.KPIS,
    title: "Mes indicateurs",
    icon: "trending_up",
    link: "/kpi",
    show: true,
    collapse: true,
    showIconCollapse: true,
  },
  {
    id: MenuToNativeId.ADMIN,
    title: "Administration",
    icon: "apps",
    link: "/admin",
    show: true,
    collapse: true,
    showIconCollapse: true,
  },
  {
    id: MenuToNativeId.PROFILE,
    title: "Mon compte",
    icon: "person",
    link: "/profile",
    show: true,
    collapse: true,
    showIconCollapse: true,
  },
  {
    id: MenuToNativeId.LOGOUT,
    title: "Déconnexion",
    icon: "logout",
    link: "logout",
    show: true,
    collapse: true,
    showIconCollapse: true,
  },
  {
    id: MenuToNativeId.MAIN_CONDO,
    title: "Syndic",
    icon: "business",
    link: "condo-mngt",
    show: false,
    collapse: true,
    showIconCollapse: true,
  },
];
